/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import DOMPurify from 'dompurify';
import { isEmpty } from 'lodash';
import { parse } from 'marked';
import { useCallback } from 'react';

import CircleLoading from '@/components/circleLoading';

import styles from './style/index.module.less';

interface IReceiveProps {
  id: string;
  name: string;
  msg: string;
  scale: number;
  isLoading: boolean;
  primary: string;
  avatar: string;
  onPlay: (id: string) => void;
}

const Receive = (props: IReceiveProps) => {
  const { id, name, avatar, msg, scale, isLoading, primary, onPlay } = props;

  const handleClick = useCallback(() => {
    onPlay(id);
  }, [onPlay, id]);


  return (
    <div className={styles.root}>
      <div className={styles.left}>
        <img className={styles.img}
          src={isEmpty(avatar) ? 'https://media-img.puui.qpic.cn/media_img/0/lena/PICrbqw08_120_120/0' : avatar}
          alt="" />
      </div>
      <div className={styles.right}>
        <div className={styles['name-wrapper']}>
          <div className={styles.name}>{name}</div>
        </div>
        <div className={styles.msg}>
          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(parse(msg) as string) }}></div>
          <div
            className={styles['audio-wrapper']}
            style={{ transform: `scale(${scale})`, background: primary }}
            onClick={handleClick}
          >
            {!isLoading && (
              <img
                className={styles['audio-icon']}
                src="https://media-img.puui.qpic.cn/media_img/0/lena/PICcp9qjo_23_21/0"
              />
            )}
            {isLoading && <CircleLoading />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default (Receive);
